import React from 'react';
import PropTypes from 'prop-types';
import PageBreadcrumbTrail from '../../../containers/PageBreadcrumbTrail';

const propTypes = {
  pageId: PropTypes.string,
  companyName: PropTypes.string,
};

const defaultProps = {
  pageId: '',
  companyName: '',
};

const Breadcrumbs = ({ pageId, companyName }) => (
  <PageBreadcrumbTrail pageId={pageId} companyName={companyName} />
);

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

export default Breadcrumbs;
